import React from "react";
import { object, array, bool, number, string } from "prop-types";
import { Link } from "@quintype/components";

import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";

import "./story-card1.m.css";

const StoryCard1 = ({ story, aspectRatio, imageType, headerType, id, showRedDot, headerLevel }) => {
  return (
    <div className="story-card story-card-1" styleName="story-card-1" id="story-card-1">
      <div className="headline-link" styleName="title-link">
        <Link href={`/${story.slug}`}>
          <Headline
            text={story.headline}
            headerType={headerType}
            headerLevel={headerLevel}
            story={story}
            width={20}
            height={20}
            id={id}
            showRedDot={showRedDot}
            eager={true}
            lineClamp={2}
          />
        </Link>
        <Link href={`/${story.slug}`}>
          <CardImage showVideoIcon={true} story={story} aspectRatio={aspectRatio} imageType={imageType} />
        </Link>
      </div>

      <Link href={`/${story.slug}`}>
        <span styleName="summary" className="summary line-clamp-3">
          {story?.subheadline
            ? story?.subheadline
            : story.seo && story.seo["meta-description"]
            ? story.seo["meta-description"]
            : null}
        </span>
      </Link>
      <div>
        <StoryDate story={story} />
      </div>
    </div>
  );
};

StoryCard1.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 1,
  headerLevel: 1,
  showSummary: true,
  isExternalStory: false,
  showRedDot: false
};

StoryCard1.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number,
  showAuthorName: bool,
  showSummary: bool,
  id: string,
  isExternalStory: bool,
  pageType: string,
  showRedDot: bool
};

export default StoryCard1;
